import {
    RequestKeys,
} from 'app/hooks/useRequest'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    TableResponse,
} from 'app/types/request.types'
import requests from 'app/requests/ContractBasis/LaneGroup/Lane/LaneOps.requests'

import {
    AvailableLanes,
} from '../AvailableLanes.types'

const useGetAvailableLanesForCTCreation = () => {
    return useRequestTable<TableResponse<AvailableLanes>>({
        config: requests.customerTransportCreationFilterRequest,
        params: {},
        defaultValue: {
            sort: {
                field: 'changedOn',
                direction: 'desc',
            },
        },
        key: RequestKeys.getAvailableLanesForCTCreation,
    })
}

export default useGetAvailableLanesForCTCreation
